const settings = {
  development: {
    googleMapsApiKey: String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY),
    firebaseConfig: {
      apiKey: process.env.REACT_APP_APIKEY,
      authDomain: process.env.REACT_APP_AUTHDOMAIN,
      projectId: process.env.REACT_APP_PROJECTID,
      appId: process.env.REACT_APP_ID,
      measurementId: process.env.REACT_APP_MEASUREMENT_ID
    },
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  },
  production: {
    googleMapsApiKey: String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY),
    firebaseConfig: {
      apiKey: process.env.REACT_APP_APIKEY,
      authDomain: process.env.REACT_APP_AUTHDOMAIN,
      projectId: process.env.REACT_APP_PROJECTID,
      appId: process.env.REACT_APP_ID,
      measurementId: process.env.REACT_APP_MEASUREMENT_ID
    },
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  },
};

const getCurrentSettings = () => {
  // if (process.env.NODE_ENV === 'development') return settings.development;
  if (process.env.NODE_ENV === 'production') return settings.production;

  return settings.development;
  // return settings.production;
};

export default getCurrentSettings();
